import { Injectable } from '@angular/core';
import {JornadaDTO} from "../../dtos/jornada.dto";

@Injectable({
  providedIn: 'root'
})
export class JornadaService {

  private jornadaSeleccionada: JornadaDTO;
  private listaUuidJornadasRecienCreadas: Array<string> = [];

  constructor() {

  }

  getJornadaSeleccionada() {
    return this.jornadaSeleccionada;
  }

  setJornadaSeleccionada(jornada: JornadaDTO) {
    this.jornadaSeleccionada = jornada;
  }

  getListaUuidJornadasRecienCreadas() {
    return this.listaUuidJornadasRecienCreadas;
  }

  addListaUuidJornadasRecienCreadas(uuid: string) {
    this.listaUuidJornadasRecienCreadas.push(uuid);
  }


}
